import React, { useContext, useState } from "react"
import { CloseButton, LocalShadow, PopupButton, PopupWrapper } from "../../../../components/styled/BasicBlocks"
import { GViewer } from "../../../desktopPage/GViewer";
import { GoodScroll } from "../../../desktopPage/GoodScroll";
import "./FullAnalysisSelectFilePopup.css";
import { IAnalysisFolder } from "./IAnalysisFolder";
import { createModalSystem } from "../../../../utils/createModalSystem";
import { AppContext } from "../../../../appContext";
import { useOutsideClick } from "../../../../utils/useOutsideClick";

interface IFullAnalysisSelectFilePopup {
    onClose: ()=>void;
    onSubmit: (item: IAnalysisFolder)=>void;
    title?: React.ReactNode;
    FileViewer: ({onSelect, callModal}: {onSelect:(item: IAnalysisFolder)=>void, callModal: (modal: (close: ()=>void)=>React.ReactNode)=>void})=>React.ReactNode;
}

export const FullAnalysisSelectFilePopup = ({onClose, onSubmit, FileViewer, title}: IFullAnalysisSelectFilePopup)=>{
    const [gSelected, setGSelected] = useState<IAnalysisFolder>(null);
    const modalSystem = createModalSystem();
    const {translate} = useContext(AppContext);
    const popupRef = useOutsideClick(onClose);

    return <LocalShadow className="FullAnalysisSelectFilePopup" onContextMenu={e=>{e.stopPropagation()}}>
        <div ref={popupRef}>
            <PopupWrapper>
                <div className="FullAnalysisSelectFilePopup_head">
                <div className="FullAnalysisSelectFilePopup_head_title">{title ?? translate('Select gDrive file')}</div>
                    <CloseButton onClick={onClose}></CloseButton>
                </div>
                <div className="FullAnalysisSelectFilePopup_scroll">
                <GoodScroll className="FullAnalysisSelectFilePopup_scroll_wrap">
                    <div className="FullAnalysisSelectFilePopup_scroll_content">
                    <FileViewer onSelect={(item)=>{setGSelected(item)}} callModal={modalSystem.callModal}></FileViewer>
                    </div>
                </GoodScroll>
                </div>
                <div className="FullAnalysisSelectFilePopup_buttons">
                    {gSelected && <PopupButton onClick={()=>{
                        onSubmit(gSelected);
                    }}>Select</PopupButton>}
                </div>
            </PopupWrapper>
        </div>
        {modalSystem.modals}
    </LocalShadow>
}